<template>
	<span>
		<ui-button
			type="secondary"
			v-if="row.offer_buy.thread_id != null"
			v-on:click="
				$inertia.visit(
					$route('threads', { active_id: row.offer_buy.thread_id })
				)
			"
		>
			{{ __("To negotiation") }}
		</ui-button>
		<ui-button
			type="primary"
			v-else
			v-on:click="
				$bus.$emit(
					'toggle-iframe-modal',
					$route('bid.create', {
						targetType: 'BUY',
						targetId: row.offer_buy.id,
					}) + '?iframe_modal=true'
				)
			"
			class="ml-auto text-sm flex-shrink-0"
			>{{ __("Offer") }}</ui-button
		>
	</span>
</template>

<script>
export default {
	props: {
		row: {
			type: Object,
			required: true,
		},
	},
};
</script>
